module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lx-box",
    style: ({
      width: _vm.screenWidth + 'px'
    })
  }, [_c('popup', {
    attrs: {
      "show": _vm.showPopup,
      "x": _vm.popupPosition.x,
      "y": _vm.popupPosition.y
    },
    on: {
      "mouseenter": _vm.handlePopupMouseEnter,
      "mouseleave": _vm.handlePopupMouseLeave,
      "giveGif": _vm.handleGiveGif
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lx-box-list",
    on: {
      "mouseleave": _vm.handleListMouseLeave
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      class: index === _vm.listIndex ? 'lx-box-list-item' : 'lx-box-list-item1',
      on: {
        "mouseenter": function($event) {
          return _vm.handleChoose(index, $event)
        }
      }
    }, [_c('img', {
      ref: "giftImages",
      refInFor: true,
      staticClass: "lx-box-list-item-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), (index != _vm.listIndex) ? _c('div', {
      staticClass: "lx-box-list-item-span"
    }, [_vm._v(_vm._s(item.giftName))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "lx-box-list-item-span1"
    }, [_vm._v(_vm._s(item.price) + "US" + _vm._s(_vm.$t('all.bi')))]), _vm._v(" "), (index == _vm.listIndex) ? _c('div', {
      staticClass: "lx-box-list-item-zs",
      on: {
        "click": _vm.giveGift
      }
    }, [_vm._v(_vm._s(_vm.$t('all.zengsong')))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "lx-box-gengduo",
    on: {
      "click": _vm.handleShowGdlw
    }
  }, [_c('img', {
    staticClass: "lx-box-gengduo-img",
    attrs: {
      "src": require("../../assets/image/zhibojian_liwu@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lx-box-gengduo-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.gengduo')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/gengduo_10@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lx-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "lx-box-jinbi"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/xunibi_32@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.virtualBalance))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d46a2e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/liwu/liwu.vue
// module id = 821
// module chunks = 1